/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespMainContent_user$ref = any;
type SbRespNullSearchResults_user$ref = any;
type SharedRecentlyViewedItems_user$ref = any;
type TradePromo_user$ref = any;
export type SbRespCollectionsComponents_user$ref = any;
export type SbRespCollectionsComponents_user = {
    readonly canShowSellerName: boolean | null;
    readonly " $fragmentRefs": TradePromo_user$ref & SbRespNullSearchResults_user$ref & SharedRecentlyViewedItems_user$ref & SbRespMainContent_user$ref;
    readonly " $refType": SbRespCollectionsComponents_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespCollectionsComponents_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "canShowSellerName",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "TradePromo_user",
                    "args": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespNullSearchResults_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SharedRecentlyViewedItems_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespMainContent_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'ea6af2f3d28f56660f9cf4cf8e7a4669';
export default node;
